import {
  useEffect,
  useState
} from 'react'
import { Text } from '@chakra-ui/react'
import { COLORS } from 'utils/styles'

export const RotatingAffinityText = ({
  key,
  affinities = [],
  style
}) => {
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (affinities.length < 2) return undefined

    const interval = setInterval(() => {
      setVisible(false)

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % affinities.length)
        setVisible(true)
      }, 500)
    }, 2500)

    return () => clearInterval(interval)
  }, [affinities])

  return (
    <Text
      key={key}
      background={COLORS.eventNotifGoldGradientLeftToRight}
      opacity={visible ? 1 : 0}
      transition="opacity 1s ease"
      sx={style}
    >
      {affinities[index]}
    </Text>
  )
}
